import _ListItemText from "@mui/material/ListItemText";
var _AccountCircleOutline, _StyledDivider, _StyledDivider2, _MoreVert, _LastPageOutlined, _FirstPageOutlined, _HelpOutline, _SettingsOutlined, _AccountCircleOutline2;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment, useRef, useState } from 'react';
import { arrayOf, bool, exact, func, shape, string, element } from 'prop-types';
import clsx from 'clsx';
import Menu, { menuClasses } from '@mui/material/Menu';
import { buttonClasses } from '@mui/material/Button';
import { AccountCircleOutlined, FirstPageOutlined, HelpOutline, LastPageOutlined, MoreVert, SettingsOutlined } from 'mosaic-react-icons';
import { alpha, styled, useTheme } from '@mui/material/styles';
import SovosIconButton from "../../../sovos-icon-button";
import SovosMenuItem from "../../../sovos-menu-item";
import SovosTypography from "../../../sovos-typography";
import SovosDivider from "../../../sovos-divider";
import { getIconSizes, spacingToNumber } from "../../../internals/utils";
import { collapsedWidthFactor } from "../../../themes/sovos-sizes";
import useMosaicTranslation from "../../../internals/i18n/useMosaicTranslation";
var Root = styled('footer', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isCollapsed' && prop !== 'navFooterHeight';
  }
})(function (_ref) {
  var isCollapsed = _ref.isCollapsed,
    navFooterHeight = _ref.navFooterHeight,
    _ref$theme = _ref.theme,
    overrides = _ref$theme.overrides,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing;
  var _ref2 = (overrides === null || overrides === void 0 ? void 0 : overrides.sovosNavigation) || {},
    _ref2$footerBackgroun = _ref2.footerBackground,
    footerBackground = _ref2$footerBackgroun === void 0 ? palette.primary.dark : _ref2$footerBackgroun;
  return {
    alignItems: 'center',
    backgroundColor: footerBackground,
    display: 'flex',
    flexDirection: isCollapsed ? 'column' : 'row',
    flexWrap: isCollapsed ? 'wrap' : 'nowrap',
    height: isCollapsed ? 'auto' : navFooterHeight,
    justifyContent: isCollapsed ? 'center' : 'flex-end',
    padding: isCollapsed ? spacing() : "0 ".concat(spacing())
  };
});
var StyledIconButton = styled(SovosIconButton, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isCollapsed';
  }
})(function (_ref3) {
  var _ref5;
  var isCollapsed = _ref3.isCollapsed,
    _ref3$theme = _ref3.theme,
    overrides = _ref3$theme.overrides,
    palette = _ref3$theme.palette,
    themeShape = _ref3$theme.shape,
    spacing = _ref3$theme.spacing;
  var _ref4 = (overrides === null || overrides === void 0 ? void 0 : overrides.sovosNavigation) || {},
    _ref4$navItemForegrou = _ref4.navItemForeground,
    navItemForeground = _ref4$navItemForegrou === void 0 ? palette.primary.contrastText : _ref4$navItemForegrou;
  return _ref5 = {
    backgroundColor: alpha(palette.primary.light, 0.08),
    borderRadius: themeShape.borderRadius,
    color: navItemForeground,
    margin: "0 ".concat(spacing(isCollapsed ? 0 : 0.5), " ").concat(spacing(isCollapsed ? 1 : 0), " ").concat(spacing(isCollapsed ? 0 : 0.5)),
    '&:last-of-type': {
      marginRight: "0"
    },
    '&:hover': {
      backgroundColor: alpha(palette.primary.light, 0.12),
      color: palette.primary.contrastText
    }
  }, _defineProperty(_ref5, "&.".concat(buttonClasses.focusVisible), {
    backgroundColor: alpha(palette.primary.light, 0.12),
    color: palette.primary.contrastText
  }), _defineProperty(_ref5, '&.sovosNavigationFooter__toggle', {
    margin: "0 ".concat(isCollapsed ? 0 : 'auto', " 0 0")
  }), _ref5;
});
var StyledMenu = styled(Menu)(_defineProperty({}, "& .".concat(menuClasses.list), {
  display: 'flex',
  flexDirection: 'column'
}));
var StyledDivider = styled(SovosDivider)(function (_ref6) {
  var _ref6$theme = _ref6.theme,
    palette = _ref6$theme.palette,
    spacing = _ref6$theme.spacing;
  return {
    backgroundColor: palette.divider,
    margin: "".concat(spacing(0.5), " ").concat(spacing(2))
  };
});
var UserMenuItem = styled('li')(function (_ref7) {
  var _ref7$theme = _ref7.theme,
    spacing = _ref7$theme.spacing,
    typography = _ref7$theme.typography;
  return {
    order: '-1',
    '& .sovosNavigation__userMenuIcon': {
      height: spacing(4),
      marginRight: spacing(0.5),
      width: spacing(4)
    },
    '& .sovosNavigation__userMenuHeader': {
      alignItems: 'center',
      display: 'flex',
      height: spacing(6),
      padding: spacing(2)
    },
    '& .sovosNavigation__userMenuName': {
      fontWeight: typography.fontWeightBold,
      overflowWrap: 'break-word'
    }
  };
});
var MenuItemPropType = shape({
  label: string,
  action: func
});
var AdditionalButtonPropType = shape({
  disabled: bool,
  icon: element.isRequired,
  label: string.isRequired,
  action: func.isRequired
});
var NavigationFooter = function NavigationFooter(_ref8) {
  var _UserMenuItem;
  var handleModalClose = _ref8.handleModalClose,
    _ref8$isCollapsed = _ref8.isCollapsed,
    isCollapsed = _ref8$isCollapsed === void 0 ? false : _ref8$isCollapsed,
    labels = _ref8.labels,
    onCollapseClicked = _ref8.onCollapseClicked,
    onHelpClicked = _ref8.onHelpClicked,
    _ref8$settingsMenuIte = _ref8.settingsMenuItems,
    settingsMenuItems = _ref8$settingsMenuIte === void 0 ? [] : _ref8$settingsMenuIte,
    _ref8$showSettingsBut = _ref8.showSettingsButton,
    showSettingsButton = _ref8$showSettingsBut === void 0 ? false : _ref8$showSettingsBut,
    _ref8$showUserButton = _ref8.showUserButton,
    showUserButton = _ref8$showUserButton === void 0 ? true : _ref8$showUserButton,
    _ref8$showHelpButton = _ref8.showHelpButton,
    showHelpButton = _ref8$showHelpButton === void 0 ? false : _ref8$showHelpButton,
    _ref8$userMenuItems = _ref8.userMenuItems,
    userMenuItems = _ref8$userMenuItems === void 0 ? [] : _ref8$userMenuItems,
    userName = _ref8.userName,
    _ref8$additionalButto = _ref8.additionalButtons,
    additionalButtons = _ref8$additionalButto === void 0 ? [] : _ref8$additionalButto;
  var _useMosaicTranslation = useMosaicTranslation(),
    t = _useMosaicTranslation.t;
  var _useTheme = useTheme(),
    spacing = _useTheme.spacing;
  var buttonSizeKey = 'small';
  var buttonSize = function buttonSize() {
    var sizes = getIconSizes(spacing);
    return sizes[buttonSizeKey].button.height;
  };
  var navFooterHeight = buttonSize() + spacingToNumber(spacing(2));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    menu = _useState4[0],
    setMenu = _useState4[1];
  var moreMenuAnchor = useRef(null);
  var userMenuAnchor = useRef(null);
  var settingsMenuAnchor = useRef(null);
  var shouldShowSettings = showSettingsButton && settingsMenuItems && settingsMenuItems.length;
  var shouldShowUser = showUserButton && userMenuItems && userMenuItems.length;
  var hideMenu = function hideMenu() {
    setMenuOpen(false);
  };
  var handleHelpClicked = function handleHelpClicked() {
    onHelpClicked();
    handleModalClose();
  };
  var handleMenuClick = function handleMenuClick(action) {
    hideMenu();
    handleModalClose();
    action();
  };
  var showMenu = function showMenu(name, menuItems, anchor) {
    setMenu({
      name: name,
      menuItems: menuItems,
      anchor: anchor
    });
    setMenuOpen(true);
  };
  var renderUserMenuHeader = function renderUserMenuHeader() {
    if (menu.name !== 'user') {
      return null;
    }
    return _UserMenuItem || (_UserMenuItem = /*#__PURE__*/React.createElement(UserMenuItem, null, /*#__PURE__*/React.createElement("header", {
      className: "sovosNavigation__userMenuHeader"
    }, _AccountCircleOutline || (_AccountCircleOutline = /*#__PURE__*/React.createElement(AccountCircleOutlined, {
      className: "sovosNavigation__userMenuIcon"
    })), /*#__PURE__*/React.createElement(SovosTypography, {
      variant: "subtitle2",
      component: "h4",
      className: "sovosNavigation__userMenuName"
    }, userName)), _StyledDivider || (_StyledDivider = /*#__PURE__*/React.createElement(StyledDivider, null))));
  };
  var renderMenuItems = function renderMenuItems(items) {
    return items === null || items === void 0 ? void 0 : items.map(function (item) {
      return /*#__PURE__*/React.createElement(SovosMenuItem, {
        className: clsx("sovosNavigationFooter__".concat(menu.name, "MenuItem--").concat(item.label)),
        onClick: function onClick() {
          return handleMenuClick(item.action);
        },
        key: item.label
      }, /*#__PURE__*/React.createElement(_ListItemText, {
        primary: item.label
      }));
    });
  };
  var renderAdditionalButtons = function renderAdditionalButtons() {
    return additionalButtons === null || additionalButtons === void 0 ? void 0 : additionalButtons.map(function (button) {
      return /*#__PURE__*/React.createElement(StyledIconButton, {
        key: button.label,
        className: "sovosNavigationFooter__additionalButton",
        isCollapsed: isCollapsed,
        onClick: button.disabled ? null : function (e) {
          return button.action(e);
        },
        size: buttonSizeKey,
        tooltipText: button.label || null,
        disabled: button.disabled || false
      }, button.icon);
    });
  };
  var renderMenu = function renderMenu() {
    var _menu$anchor;
    var menuTop = (navFooterHeight - buttonSize()) / 2 + spacingToNumber(spacing());
    var collapsedMenuX = (spacingToNumber(spacing(collapsedWidthFactor)) - buttonSize()) / 2 + buttonSize() + spacingToNumber(spacing());
    var menuItems;
    if (menu.name === 'more') {
      menuItems = renderMenuItems(userMenuItems);
      if (shouldShowSettings) {
        var _menuItems;
        if (shouldShowUser) {
          menuItems.push(_StyledDivider2 || (_StyledDivider2 = /*#__PURE__*/React.createElement(StyledDivider, {
            key: "more-divider"
          })));
        }
        (_menuItems = menuItems).push.apply(_menuItems, _toConsumableArray(renderMenuItems(settingsMenuItems)));
      }
    } else {
      menuItems = renderMenuItems(menu.menuItems);
    }
    return /*#__PURE__*/React.createElement(StyledMenu, {
      anchorEl: (_menu$anchor = menu.anchor) === null || _menu$anchor === void 0 ? void 0 : _menu$anchor.current,
      anchorOrigin: {
        horizontal: isCollapsed ? collapsedMenuX : 0,
        vertical: isCollapsed ? 'bottom' : -menuTop
      },
      className: "sovosNavigationFooter__".concat(menu.name, "Menu"),
      marginThreshold: 10,
      onClose: hideMenu,
      open: menuOpen,
      transformOrigin: {
        horizontal: 'left',
        vertical: 'bottom'
      }
    }, menuItems, renderUserMenuHeader());
  };
  return /*#__PURE__*/React.createElement(Root, {
    className: "sovosNavigationFooter",
    isCollapsed: isCollapsed,
    navFooterHeight: navFooterHeight
  }, isCollapsed && /*#__PURE__*/React.createElement(React.Fragment, null, renderAdditionalButtons(), (shouldShowUser || shouldShowSettings) && /*#__PURE__*/React.createElement(StyledIconButton, {
    sx: {
      mb: 1
    },
    isCollapsed: isCollapsed,
    onClick: function onClick() {
      return showMenu('more', [], moreMenuAnchor);
    },
    ref: moreMenuAnchor,
    size: buttonSizeKey,
    tooltipText: (labels === null || labels === void 0 ? void 0 : labels.moreIcon) || t('more')
  }, _MoreVert || (_MoreVert = /*#__PURE__*/React.createElement(MoreVert, null)))), /*#__PURE__*/React.createElement(StyledIconButton, {
    className: "sovosNavigationFooter__toggle",
    isCollapsed: isCollapsed,
    onClick: onCollapseClicked,
    size: buttonSizeKey,
    tooltipText: isCollapsed ? (labels === null || labels === void 0 ? void 0 : labels.expandIcon) || t('navigationFooter.expand') : (labels === null || labels === void 0 ? void 0 : labels.collapseIcon) || t('navigationFooter.collapse')
  }, isCollapsed ? _LastPageOutlined || (_LastPageOutlined = /*#__PURE__*/React.createElement(LastPageOutlined, null)) : _FirstPageOutlined || (_FirstPageOutlined = /*#__PURE__*/React.createElement(FirstPageOutlined, null))), !isCollapsed && renderAdditionalButtons(), !isCollapsed && showHelpButton && /*#__PURE__*/React.createElement(StyledIconButton, {
    className: "sovosNavigationFooter__helpButton",
    isCollapsed: isCollapsed,
    onClick: handleHelpClicked,
    size: buttonSizeKey,
    tooltipText: (labels === null || labels === void 0 ? void 0 : labels.helpIcon) || t('navigationFooter.help')
  }, _HelpOutline || (_HelpOutline = /*#__PURE__*/React.createElement(HelpOutline, null))), !isCollapsed && shouldShowSettings && /*#__PURE__*/React.createElement(StyledIconButton, {
    className: "sovosNavigationFooter__settingsButton",
    isCollapsed: isCollapsed,
    onClick: function onClick() {
      return showMenu('settings', settingsMenuItems, settingsMenuAnchor);
    },
    ref: settingsMenuAnchor,
    size: buttonSizeKey,
    tooltipText: (labels === null || labels === void 0 ? void 0 : labels.settingsIcon) || t('settings')
  }, _SettingsOutlined || (_SettingsOutlined = /*#__PURE__*/React.createElement(SettingsOutlined, null))), !isCollapsed && shouldShowUser && /*#__PURE__*/React.createElement(StyledIconButton, {
    className: "sovosNavigationFooter__userButton",
    isCollapsed: isCollapsed,
    onClick: function onClick() {
      return showMenu('user', userMenuItems, userMenuAnchor);
    },
    ref: userMenuAnchor,
    size: buttonSizeKey,
    tooltipText: (labels === null || labels === void 0 ? void 0 : labels.userIcon) || t('yourAccount')
  }, _AccountCircleOutline2 || (_AccountCircleOutline2 = /*#__PURE__*/React.createElement(AccountCircleOutlined, null))), renderMenu());
};
NavigationFooter.propTypes = {
  isCollapsed: bool,
  handleModalClose: func.isRequired,
  labels: exact({
    collapseIcon: string,
    expandIcon: string,
    helpIcon: string,
    moreIcon: string,
    settingsIcon: string,
    userIcon: string
  }),
  onCollapseClicked: func,
  onHelpClicked: func,
  showSettingsButton: bool,
  showUserButton: bool,
  showHelpButton: bool,
  settingsMenuItems: arrayOf(MenuItemPropType),
  userName: string,
  userMenuItems: arrayOf(MenuItemPropType),
  additionalButtons: arrayOf(AdditionalButtonPropType)
};
export default NavigationFooter;